import { UIOption } from './ui-option';
import { Component } from '../../decorators/component.decorator';
import styles from './ui-option-color.css';
import { Attribute } from '../../decorators/attribute.decorator';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIOptionColor
 * @element ui-option-color
 * @classdesc Represents a class for <code>ui-option-color</code> element.
 * Similar to ui-option, but holds color. Used with
 * <code>ui-dropdown layout="color"</code> and <code>ui-option-list</code>.
 * @property {string} [color] {@attr color} Icon color. Custom property or color name/hex.
 * @property {boolean} [customproperty] {@attr customproperty} Is custom property.
 * @example
 * <ui-dropdown layout="color">
 *   <select>
 *     <option data-color="--ui-color-orange" data-customproperty="true">Orange</option>
 *     <option data-color="#5B8AD6">Blue</option>
 *   </select>
 * </ui-dropdown>
 * @example
 * <ui-option-list label="Select color">
 *   <ui-option-color optgroup text="Brand colors"></ui-option-color>
 *   <ui-option-color color="--ui-color-orange" customproperty text="Orange"></ui-option-color>
 *   <ui-option-color color="--ui-color-lilac" customproperty selected text="Lilac"></ui-option-color>
 * </ui-option-list>
 */

@Component({
    tag: 'ui-option-color',
    styles,
})
export class UIOptionColor extends UIOption {
    @Attribute(String) color?: string;
    @Attribute(Boolean) customproperty?: boolean;

    /**
     * @inheritDoc
     */
    render(): void {
        this.insertElements(
            this.optgroup
                ? [this.buildOptGroupLabel()]
                : [
                      {
                          tagName: 'div',
                          attributes: {
                              class: 'ui-option-color__box',
                              style: `background-color: ${
                                  this.customproperty
                                      ? `var(${this.color})`
                                      : this.color
                              };`,
                          },
                      },
                      {
                          tagName: 'span',
                          attributes: {
                              class: 'ui-option-color__label ui-option__label',
                          },
                          children: [
                              this.getAttribute('text') ||
                                  this.getAttribute('value') ||
                                  '',
                          ],
                      },
                  ]
        );

        super.render();
    }
}
